export default "__VITE_ASSET__8kDx1PjS__"